module.exports = __webpack_public_path__ + "static/media/bi.aeb33354.png";